import { YesNo } from '@/components/ui/button-group'
import { Field, FieldLabel } from '@/components/ui/field'

export interface BusinessDraft {
  hazmat: boolean | null
  interstate: boolean | null
}

export const STEP_BUSINESS_QUESTION = 'Can you confirm the following info about your business?'

/** Step 2: the two answers the DOT lookup cannot be trusted on. */
export function StepBusiness({
  value,
  onChange,
}: {
  value: BusinessDraft
  onChange: (next: BusinessDraft) => void
}) {
  return (
    <div className="flex flex-col items-start gap-6">
      <Field className="w-auto" role="group" aria-label="Hazmat">
        <FieldLabel>Do you haul hazmat?</FieldLabel>
        <YesNo value={value.hazmat} onChange={(hazmat) => onChange({ ...value, hazmat })} className="w-40" />
      </Field>
      <Field className="w-auto" role="group" aria-label="Interstate">
        <FieldLabel>Do you run interstate?</FieldLabel>
        <YesNo
          value={value.interstate}
          onChange={(interstate) => onChange({ ...value, interstate })}
          className="w-40"
        />
      </Field>
    </div>
  )
}
